import React, { useState } from 'react'

export const UserMobileFlow = () => {
  const [phone, setPhone] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)

  const onSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false)
      setIsSubmitted(true)
    }, 1000)
  }

  const formatPhoneNumber = (value) => {
    // Remove all non-numeric characters
    const phoneNumber = value.replace(/[^\d]/g, '')
    
    // Format as (XXX) XXX-XXXX
    if (phoneNumber.length <= 3) {
      return phoneNumber
    } else if (phoneNumber.length <= 6) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
    } else {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
    }
  }

  const handlePhoneChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value)
    setPhone(formatted)
  }

  if (isSubmitted) {
    return (
      <div style={styles.container}>
        <div style={styles.successCard}>
          <div style={styles.successIcon}>✓</div>
          <h1 style={styles.successTitle}>You've Been Subscribed!</h1>
          <p style={styles.successMessage}>
            You'll now receive notifications for asset prices and trade updates at <strong>{phone}</strong>
          </p>
          <p style={styles.successSubMessage}>
            Thank you for subscribing to YOLO mobile notifications.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>Mobile Notifications</h1>
          <p style={styles.subtitle}>
            Stay updated with real-time asset prices and trade notifications
          </p>
        </div>

        <form onSubmit={onSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              Mobile Number
            </label>
            <div style={styles.inputWrapper}>
              <span style={styles.countryCode}>🇺🇸 +1</span>
              <input
                type="tel"
                value={phone}
                onChange={handlePhoneChange}
                placeholder="(555) 123-4567"
                required
                style={styles.input}
                maxLength={14}
              />
            </div>
          </div>

          <div style={styles.notificationTypes}>
            <h3 style={styles.notificationTitle}>You'll receive notifications for:</h3>
            <div style={styles.notificationList}>
              <div style={styles.notificationItem}>
                📈 <span>Asset price alerts and market updates</span>
              </div>
              <div style={styles.notificationItem}>
                💼 <span>Trade execution confirmations</span>
              </div>
              <div style={styles.notificationItem}>
                🎯 <span>Portfolio performance summaries</span>
              </div>
            </div>
          </div>

          <p style={styles.disclaimer}>
            By submitting, you agree to receive SMS messages from YOLO about asset prices and your trades. 
            Msg & data rates may apply. Reply STOP to unsubscribe or HELP for help.
          </p>

          <button 
            type="submit" 
            style={{
              ...styles.submitButton,
              ...(isSubmitting ? styles.submitButtonLoading : {})
            }}
            disabled={isSubmitting || phone.length < 14}
          >
            {isSubmitting ? (
              <>
                <span style={styles.spinner}></span>
                Subscribing...
              </>
            ) : (
              'Subscribe to Notifications'
            )}
          </button>
        </form>
      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  },
  card: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    padding: '3rem',
    maxWidth: '500px',
    width: '100%',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)'
  },
  successCard: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    padding: '3rem',
    maxWidth: '400px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)'
  },
  header: {
    textAlign: 'center',
    marginBottom: '2.5rem'
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: '700',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    margin: '0 0 0.5rem 0'
  },
  subtitle: {
    fontSize: '1.1rem',
    color: '#6b7280',
    margin: 0,
    lineHeight: '1.5'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  },
  label: {
    fontSize: '0.95rem',
    fontWeight: '600',
    color: '#374151'
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    background: '#f9fafb',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    overflow: 'hidden',
    transition: 'border-color 0.2s ease',
    ':focus-within': {
      borderColor: '#667eea'
    }
  },
  countryCode: {
    padding: '1rem',
    backgroundColor: '#f3f4f6',
    borderRight: '1px solid #e5e7eb',
    fontSize: '0.95rem',
    fontWeight: '500',
    color: '#374151'
  },
  input: {
    flex: 1,
    padding: '1rem',
    border: 'none',
    outline: 'none',
    fontSize: '1rem',
    background: 'transparent',
    color: '#111827'
  },
  notificationTypes: {
    padding: '1.5rem',
    background: '#f8fafc',
    borderRadius: '12px',
    border: '1px solid #e2e8f0'
  },
  notificationTitle: {
    fontSize: '1rem',
    fontWeight: '600',
    color: '#374151',
    margin: '0 0 1rem 0'
  },
  notificationList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem'
  },
  notificationItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    fontSize: '0.95rem',
    color: '#4b5563'
  },
  disclaimer: {
    fontSize: '0.85rem',
    color: '#6b7280',
    lineHeight: '1.5',
    margin: 0,
    padding: '1rem',
    background: '#fefce8',
    border: '1px solid #fde047',
    borderRadius: '8px'
  },
  submitButton: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    padding: '1rem 2rem',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    ':hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 10px 20px rgba(102, 126, 234, 0.4)'
    },
    ':disabled': {
      opacity: 0.7,
      cursor: 'not-allowed',
      transform: 'none'
    }
  },
  submitButtonLoading: {
    opacity: 0.8,
    cursor: 'not-allowed'
  },
  spinner: {
    width: '16px',
    height: '16px',
    border: '2px solid transparent',
    borderTop: '2px solid white',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  successIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '2rem',
    color: 'white',
    margin: '0 auto 1.5rem auto'
  },
  successTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#111827',
    margin: '0 0 1rem 0'
  },
  successMessage: {
    fontSize: '1rem',
    color: '#6b7280',
    margin: '0 0 1rem 0',
    lineHeight: '1.5'
  },
  successSubMessage: {
    fontSize: '0.9rem',
    color: '#9ca3af',
    margin: 0,
    lineHeight: '1.4'
  }
}

